/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Features_Timeline_TitleInputs */

const en_fc_home_features_timeline_title = /** @type {(inputs: Fc_Home_Features_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timeline editing`)
};

/**
* | output |
* | --- |
* | "Timeline editing" |
*
* @param {Fc_Home_Features_Timeline_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_features_timeline_title = /** @type {((inputs?: Fc_Home_Features_Timeline_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Features_Timeline_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_features_timeline_title(inputs)
});
export { fc_home_features_timeline_title as "fc.home.features.timeline.title" }